<template>
	<div class='story' >
		<h2 v-html="getContent(content.titel)"></h2>
		<Swiper :slides='content.slides' :lang='lang' />
	</div>
</template>

<script>
	import Swiper from './components/swiper';

	import './scss/index.scss';
	import './app.scss';

	export default {
		name: 'App',
		data() {
			return {
				content: this.$store.state.content,
				lang: "nl"
			}
		},
		mounted: function() {
			console.log("in app", this.content.slides);
		},
		methods: {
			getContent(content) {
				if (this.lang === "nl") {
					return content.data;
				}
				else {
					return content.data5891;	
				}
			}
		},
		components: {
			Swiper
		}
	}
</script>
